import script from "./CoursePreviewView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoursePreviewView.vue?vue&type=script&lang=ts&setup=true"

import "./CoursePreviewView.vue?vue&type=style&index=0&id=1fb9bbdd&lang=css"

const __exports__ = script;

export default __exports__